import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import Dashboard from './views/Dashboard.vue'
import Profile from './views/Profile.vue'
import EditProfile from './views/EditProfile.vue'
import Community from './views/Community.vue'
import Member from './views/Member.vue'
import AddCommunity from './views/AddCommunity.vue'
import EditCommunity from './views/EditCommunity.vue'
import CommunityMembers from './views/CommunityMembers.vue'
import ViewMember from './views/ViewMember.vue'
import ViewPolicy from './views/ViewPolicy.vue'
import Claims from './views/Claims.vue'
import MemberClaim from './views/MemberClaim.vue'
import Transactions from './views/Transactions.vue'
import ViewTransaction from './views/ViewTransaction.vue'
import Consultants from './views/Consultants.vue'
import MarketingConsultant from './views/MarketingConsultant.vue'
import ViewMarketingConsultant from './views/ViewMarketingConsultant.vue'
import AddMarketingConsultant from './views/AddMarketingConsultant.vue'
import LossAssessors from './views/LossAssessors.vue'
import ViewLossAssessor from './views/ViewLossAssessor.vue'
import AddLossAssessors from './views/AddLossAssessors.vue'
import ViewConsultant from './views/ViewConsultant.vue'
import RegisterConsultant from './views/RegisterConsultant.vue'
import Subscriptions from './views/Subscriptions.vue'
import Report from './views/Report.vue'
import MakePayment from './views/MakePayment.vue'
import Notifications from './views/Notifications.vue'
import PaystackView from './views/PaystackView.vue'
import flutter from './views/flutter.vue'
import PageNotFound from './views/404.vue'
import mainlayout from '@/layout/mainlayout'
import AuthLayout from '@/layout/AuthLayout'
// import AstraLogin from '@/components/AstraLogin'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
   
{
  path: '/dashboard',
  redirect: 'dashboard',
  component: mainlayout,
  children: [
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/fluttertest',
      name: 'flutter',
      component: flutter
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/profile/editProfile',
      name: 'editProfile',
      component: EditProfile
    },
    {
      path: '/community',
      name: 'community',
      component: Community
    },
    {
      path: '/member',
      name: 'member',
      component: Member
    },
    {
      path: '/community/members',
      name: 'communityMembers',
      component: CommunityMembers
    },
    {
      path: '/community/addCommunity',
      name: 'addCommunity',
      component: AddCommunity
    },
    {
      path: '/community/editCommunity',
      name: 'editCommunity',
      component: EditCommunity
    },

    {
      path: '/community/members/:id',
      name: 'viewMember',
      component: ViewMember
    },
    {
      path: '/community/members/viewPolicy/:id',
      name: 'viewPolicy',
      component: ViewPolicy
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications
    },
    {
      path: '/makepayments',
      name: 'paystackview',
      component: PaystackView
    },
    {
      path: '/claims',
      name: 'claims',
      component: Claims
    },
    {
      path: '/claims/:id',
      name: 'memberClaim',
      component: MemberClaim
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: Transactions
    },
    {
      path: '/transactions/viewTransaction/:id',
      name: 'viewTransaction',
      component: ViewTransaction
    },
    {
      path: '/consultants',
      name: 'consultants',
      component: Consultants
    },
    {
      path: '/marketing_consultants',
      name: 'marketingConsultants',
      component: MarketingConsultant
    },
    {
      path: '/marketing_consultants/viewMarketingConsultant/:id',
      name: 'viewMarketingConsultants',
      component: ViewMarketingConsultant
    },
    {
      path: '/marketing_consultants/register_marketing_consultant',
      name: 'addMarketingConsultants',
      component: AddMarketingConsultant
    },
    {
      path: '/loss_assessors',
      name: 'lossAssessors',
      component: LossAssessors
    },
    {
      path: '/loss_assessors/viewLossAssessor/:id',
      name: 'viewLossAssessors',
      component: ViewLossAssessor
    },
    {
      path: '/loss_assessors/register_loss_assessors',
      name: 'addLossAssessors',
      component: AddLossAssessors
    },
    {
      path: '/claims/makepayment/:id',
      name: 'makepayment',
      component: MakePayment
    },
    {
      path: '/consultants/viewConsultant/:id',
      name: 'viewConsultant',
      component: ViewConsultant
    },
    {
      path: '/consultants/registerConsultant',
      name: 'registerConsultant',
      component: RegisterConsultant
    },
    {
      path: '/subscriptions',
      name: 'subscriptions',
      component: Subscriptions
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: function () { 
        return import(/* webpackChunkName: "about" */ './views/About.vue')
      }
    }
     
  ]
},
{
  path: '/',
  redirect: 'login',
  component: AuthLayout,
  children: [
      {
          path: '/login',
          name: 'Login',
          component: Login 
          
      },
      {
        path: '/forgot',
        name: 'ForgotPassword',
        component: ForgotPassword
      },
      {
        path: 'makepaymentmobile',
        name: 'makepayment',
        component: MakePayment
      },
     
  ]
},
{
  path:'*',
  name:'PageNotFound',
  component:PageNotFound
}

  
  ]
})
